<template>
  <rest-page :fetch-endpoint="fetchEndpoint">
    <rest-form
      ref="form"
      :after-save="afterSave"
      :fetch-endpoint="fetchEndpoint"
      :model="model"
      :rules="rules"
      :save-endpoint="saveEndpoint"
    >
      <app-android-huawei-form
        v-if="
          type === ApplicationTypes.android &&
            subType === ApplicationSubTypes.huawei
        "
        :model="model"
      />
      <app-android-form
        v-else-if="type === ApplicationTypes.android"
        :model="model"
      />
      <app-ios-form v-if="type === ApplicationTypes.ios" :model="model" />
      <app-web-form
        v-if="type === ApplicationTypes.web"
        :files="files"
        :model="model"
      />
    </rest-form>
  </rest-page>
</template>

<script>
import RestForm from '@/common/components/rest/RestForm'
import { projectEndpoint } from '@/core/helpers'
import RestPage from '@/common/components/rest/RestPage'
import AppAndroidForm from '@/modules/account/components/AppAndroidForm'
import AppAndroidHuaweiForm from '@/modules/account/components/AppAndroidHuaweiForm'
import {
  ApplicationSubTypes,
  ApplicationTypes
} from '@/modules/account/enum/ApplicationEnum'
import AppIosForm from '@/modules/account/components/AppIosForm'
import AppWebForm from '@/modules/account/components/AppWebForm'
import { EventBus } from '@/core/EventBus'

export default {
  name: 'AppForm',
  components: {
    AppWebForm,
    AppIosForm,
    AppAndroidForm,
    AppAndroidHuaweiForm,
    RestPage,
    RestForm
  },
  props: {
    type: {
      required: true
    },
    subType: {
      required: false
    }
  },
  data() {
    return {
      model: {},
      files: {
        web_icon_small_file: {},
        web_icon_large_file: {},
        ios_production_key_file: {},
        ios_sandbox_key_file: {}
      },
      ApplicationTypes,
      ApplicationSubTypes
    }
  },
  mounted() {
    this.resetForm()
  },
  computed: {
    fetchEndpoint() {
      if (this.$route.query.id) {
        return projectEndpoint({
          method: 'get',
          url: `applications/${this.$route.query.id}`,
          handler: data => {
            this.model = data
          }
        })
      } else {
        return null
      }
    },

    saveEndpoint() {
      if (this.$route.query.id) {
        return projectEndpoint({
          method: 'patch',
          url: `applications/${this.$route.query.id}`
        })
      } else {
        return projectEndpoint({
          method: 'post',
          url: 'applications'
        })
      }
    },

    rules() {
      return {
        name: {
          required: true,
          message: this.$t('RestForm_FieldIsRequired')
        },
        huawei_app_id: {
          required: true,
          message: this.$t('RestForm_FieldIsRequired')
        },
        web_icon_small: {
          required: true
        },
        web_icon_large: [
          {
            required: true
          }
        ]
      }
    },
    defaultModel() {
      return {
        type: this.type,
        project_id: this.$route.query.project_id
      }
    }
  },
  methods: {
    resetForm() {
      if (!this.$route.query.id) {
        this.model = { ...this.defaultModel }
      }
    },
    afterSave(data, callback) {
      this.model = data
      this.$store.dispatch('reloadProjectConfig')
      if (!this.$route.query.id) {
        this.$router.push({
          name: 'ApplicationChannels',
          query: {
            id: data.id,
            project_id: this.model.project_id
          }
        })
      } else {
        EventBus.$emit('closeAppDialogs')
      }
      if (callback) {
        callback()
      }
    }
  }
}
</script>

<style scoped>
>>> .page {
  background: white;
  overflow-x: hidden;
}
</style>



// WEBPACK FOOTER //
// src/modules/account/components/AppForm.vue